import { colors, IMForm } from '@insurancemenu/imenu-components-lib';
import { CSSProp, styled } from 'styled-components';

export const IMFormStyled = styled(IMForm)`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  margin: 0 auto;
  padding: 6rem 10rem;
  max-width: 100%;
  position: relative;
`;

export const GuidelinesStyled = styled.p<{ $isUserInTheSystem: boolean }>`
  text-align: center;
  font-size: 1.6rem;
  line-height: 2.4rem;
  padding: 2rem;
  border-radius: 10px;
  background-color: ${({ $isUserInTheSystem }): CSSProp => ($isUserInTheSystem ? colors.red[200] : colors.blue[200])};
  margin-bottom: 3rem;
`;
